// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3 7.3V2.99C3 2.17 3.67 1.5 4.49 1.5H6.5C7.2 1.5 7.87 1.61 8.5 1.81C10.64 2.5 12.3 4.28 12.83 6.5C12.94 6.98 13 7.48 13 8V12.5C13 13.6 12.1 14.5 11 14.5H10.5M8.5 1.81V4.5C8.5 5.6 9.39 6.5 10.5 6.5H12.83',
  'M3.75 10L1.5 12.25L3.75 14.5M6.25 10L8.5 12.25L6.25 14.5',
];
